import {
    ADD_ACCOUNT,
    DELETE_BANK_ACCOUNT_BY_MERCHANT,
    GET_BANK_ACCOUNT_BY_MERCHANT,
    SET_ACCOUNT,
    SET_BANK_DELETE,
    SET_UPDATE_BANK_ACCOUNT,
    UPDATE_BANK_ACCOUNT_BY_MERCHANT
} from './actionTypes';

export const addAccount = data => {
    return {
        type: ADD_ACCOUNT,
        payload: data
    };
};

export const setAccount = data => {
    return {
        type: SET_ACCOUNT,
        payload: data
    };
};

export const getBankAccountByMerchant = data => {
    return {
        type: GET_BANK_ACCOUNT_BY_MERCHANT,
        payload: data
    };
};

export const updateBankAccountByMerchant = data => {
    return {
        type: UPDATE_BANK_ACCOUNT_BY_MERCHANT,
        payload: data
    };
};
export const deleteBankAccountByMerchant = data => {
    return {
        type: DELETE_BANK_ACCOUNT_BY_MERCHANT,
        payload: data
    };
};

export const setUpdateBankAccount = data => {
    return { type: SET_UPDATE_BANK_ACCOUNT, payload: data };
};
export const setBankDelete = data => {
    return { type: SET_BANK_DELETE, payload: data };
};
